import { Button } from '@wedding-tech/ui/button'
import { Loader2, UserPlus } from 'lucide-react'
import { Fragment } from 'react'

import { FullPageSpinnerPortal } from '@/components/common/Spinner/FullPagePortal'

import { CheckinLayout } from './CheckinLayout'

interface ManualStepProps {
  onBack: () => void
  form: any
  submitError: string
  isCheckinPending: boolean
}

export function ManualStep({
  onBack,
  form,
  submitError,
  isCheckinPending,
}: ManualStepProps) {
  return (
    <Fragment>
      <CheckinLayout
        title="ลงทะเบียนด้วยตนเอง"
        subtitle="กรอกข้อมูลเพื่อเช็กอินเข้าร่วมงานทันที"
        icon={<UserPlus className="size-7" />}
        onBack={onBack}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault()
            e.stopPropagation()
            form.handleSubmit()
          }}
          className="space-y-5"
        >
          {submitError && (
            <div className="text-destructive bg-destructive/10 rounded-xl p-3 text-center text-sm font-medium">
              {submitError}
            </div>
          )}

          <form.AppField name="fullName">
            {(field: any) => (
              <field.TextField
                label="ชื่อ - นามสกุล หรือชื่อเล่น *"
                placeholder="กรอกชื่อของคุณ"
              />
            )}
          </form.AppField>

          <form.AppField name="displayName">
            {(field: any) => (
              <field.TextField
                label="ชื่อที่ต้องการให้แสดงในงาน *"
                placeholder="กรอกชื่อที่ต้องการให้แสดง"
              />
            )}
          </form.AppField>

          <form.AppField name="followers">
            {(field: any) => (
              <field.SelectField
                label="จำนวนผู้เข้าร่วม *"
                options={[
                  { value: '1', label: '1 ท่าน' },
                  { value: '2', label: '2 ท่าน' },
                  { value: '3', label: '3 ท่าน' },
                  { value: '4', label: '4 ท่าน' },
                  { value: '5', label: '5 ท่าน' },
                ]}
              />
            )}
          </form.AppField>

          <div className="pt-2">
            <Button
              type="submit"
              size="lg"
              disabled={isCheckinPending}
              className="w-full font-semibold"
            >
              {isCheckinPending ? (
                <span className="flex items-center gap-2">
                  <Loader2 className="size-4 animate-spin" />
                  กำลังดำเนินการ...
                </span>
              ) : (
                'ยืนยันการเช็กอิน'
              )}
            </Button>
          </div>
        </form>
      </CheckinLayout>
      {(form.state.isSubmitting || isCheckinPending) && (
        <FullPageSpinnerPortal />
      )}
    </Fragment>
  )
}
